/**
 * Section ids that CMS authors reuse across multiple sections on one page.
 * These need a unique suffix; explicit navigation anchors (e.g. pylon-ai-benefits)
 * must stay unchanged so secondary navigation hash links keep working.
 */
const DUPLICATE_PRONE_SECTION_IDS = new Set(['dark-section', 'light-section']);

/**
 * Builds a unique, anchor-friendly section id.
 * CMS authors sometimes reuse generic ids (e.g. "dark-section") across sections.
 */
export function resolveContentSectionId(
  customId: string | undefined | null,
  sectionSysId: string | undefined,
  firstItemSysId?: string
): string | undefined {
  const trimmed = customId?.trim();
  const uniqueSuffix = firstItemSysId ?? sectionSysId;

  if (!trimmed) {
    return uniqueSuffix ? `section-${uniqueSuffix}` : undefined;
  }

  if (
    !uniqueSuffix ||
    !DUPLICATE_PRONE_SECTION_IDS.has(trimmed.toLowerCase())
  ) {
    return trimmed;
  }

  return `${trimmed}-${uniqueSuffix}`;
}
